const replace = (name) => {
  if (typeof name === "undefined") {
    return ""
  }
  let finalName = name.replace("Workplace One ", "")
  finalName = finalName.replace("workplace one ", "")
  finalName = finalName.replace("workplaceOne ", "")
  finalName = finalName.replace("WORKPLACEONE ONE ", "")
  return finalName
}
export default replace
